import React, { useState, useEffect } from 'react';
import { Tabla } from './Tabla';
import { DragHandleOutlined } from '@mui/icons-material';
import ComercialTabla from '../types/ComercialTabla';
import ObtenerAgentesComerciales from '../functions/ObtenerAgentesComerciales';

interface ListarAgentesComercialesProps {
    defaultItemsPerPage?: number;
    handleEdit: (agentecomercial: ComercialTabla) => void;
    handleDelete: (agentecomercial: ComercialTabla) => void;
    handleAdd: () => void
}

export const ListarAgentesComerciales: React.FC<ListarAgentesComercialesProps> = ({ defaultItemsPerPage = 15, handleEdit, handleDelete, handleAdd, }) => {
  
  const [agentesComerciales, setAgentesComerciales] = useState<ComercialTabla[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [itemsPerPage, setItemsPerPage] = useState(defaultItemsPerPage);

  useEffect(() => {
    const fetchAgentesComerciales = async () => {
      try {
        const data = await ObtenerAgentesComerciales();
        setAgentesComerciales(data.agentescomerciales);
        setLoading(false);
      } catch (err) {
        setError('Error al obtener los agentes comerciales:' + err);
        setLoading(false);
      }
    };

    fetchAgentesComerciales();
  }, []);

  const columns = [
    { key: 'id', label: 'ID', align: 'center' as const },
    { key: 'codigo', label: 'CODIGO', align: 'left' as const },
    { key: 'nombrefan', label: 'NOMBRE COMERCIAL', align: 'left' as const },
    { key: 'apellido', label: 'APELLIDO', align: 'left' as const },
    { key: 'nombres', label: 'NOMBRES', align: 'left' as const },
    { key: 'localidad', label: 'LOCALIDAD', align: 'left' as const },
    { key: 'habilitado', label: 'HABILITADO', align: 'center' as const },
    { key: 'dadobaja', label: 'DADO DE BAJA', align: 'center' as const },
  ];

  const handleEditLocal = (agentecomercial: ComercialTabla) => {
    handleEdit(agentecomercial);
  };

  const handleDeleteLocal = (agentecomercial: ComercialTabla) => {
    handleDelete(agentecomercial);
  };

  const handleCredencialLocal = (agentecomercial: ComercialTabla) => {
    console.log('Mostrar credencial', agentecomercial);
  }

  const handleUbicationLocal = (agentecomercial: ComercialTabla) => {
    console.log('Mostrar ubicacion', agentecomercial);
  };

  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-5">
      <div className="flex flex-row justify-between items-center mb-3">
        <div className="flex flex-col justify-center items-center">
          <h1 className="font-metropolis text-xl font-bold">Agentes Comerciales cargados</h1>
        </div>
        <div className="flex flex-col justify-center items-center">
          <button className="vp-btn-azul-sm" onClick={handleAdd}>Nuevo Agente Comercial</button>
        </div>
      </div>
      <Tabla columns={columns} data={agentesComerciales} onEdit={handleEditLocal} onDelete={handleDeleteLocal} itemsPerPage={itemsPerPage} onCredencial={handleCredencialLocal} onUbication={handleUbicationLocal} acciones={['editar','eliminar']}/>
    </div>
  );
};